import React from 'react';
import styled, { withTheme } from 'styled-components';
import { TopNavBar, Screen, BottomTabBar, PFList } from '../components';
import txs from '../data/portfolioCoins.json';

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  padding: 2px 0;
  background: ${props => props.theme.fav.bg};
`;

const Portfolio = ({ theme }) => (
  <Screen theme={theme} title="Portfolio">
    <TopNavBar title="Portfolio" left="ios-grid-outline" right="ios-add" rightSize="32px" />
    <Content>
      <PFList txs={txs} />
    </Content>
    <BottomTabBar selected="portfolio" />
  </Screen>
);

export default withTheme(Portfolio);



// WEBPACK FOOTER //
// ./src/screens/Portfolio.js